module.exports = __webpack_public_path__ + "img/loading.e8e982dc.gif";